export class UpdateOrderServicesMessage { 
  orderServiceIds: number[]

  constructor(orderServiceIds: number[]) {
    this.orderServiceIds = orderServiceIds
  }
}